import graphql__fa2bc0cc586cd85dccbe from "./__generated__/PageSectionSidebarCalendar_pageSection.graphql.js";import { graphql, useFragment } from "react-relay";

import PageSectionSidebarBlock from "./PageSectionSidebarBlock";
import Calendar from "../Calendar/Calendar";

const PageSectionSidebarCalendar = props => {
  const pageSection = useFragment(
    PageSectionSidebarCalendar_pageSection,
    props.pageSection
  );
  const { title, description } = pageSection;

  return (
    <div className="container page-section page-section-calendar">
      <PageSectionSidebarBlock
        title={title}
        description={description}
        iconClassName="icon-calendar"
      >
        <div className="calendar-section-container">
          <Calendar section={pageSection} />
        </div>
      </PageSectionSidebarBlock>
    </div>
  );
};

const PageSectionSidebarCalendar_pageSection = graphql__fa2bc0cc586cd85dccbe;

export default PageSectionSidebarCalendar;
